import { render } from "./EventsPage.vue?vue&type=template&id=efebaa50"
import script from "./EventsPage.vue?vue&type=script&lang=js"
export * from "./EventsPage.vue?vue&type=script&lang=js"

import "./EventsPage.vue?vue&type=style&index=0&id=efebaa50&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__